(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["country-recommend-modal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', (event) => {
    console.log("shopify:section:load 2");
  });

  } catch(e) { console.error(e); }
})();
})();
